export const courcesNav = () => {
    var innerPageNav = document.querySelector('.inner-page-nav');

    if(!innerPageNav) return;

    innerPageNav.addEventListener('click', function (e) {
        e.preventDefault();
        var link = e.target;
        var parentLi = link.closest('li');
        var index = Array.from(parentLi.parentNode.children).indexOf(parentLi) + 1;
        var courseListingItem = document.querySelector('.courses-cat-listing>.jet-listing>.jet-listing-grid__items>.jet-listing-grid__item:nth-child(' + index + ')');
        var top = courseListingItem.offsetTop;
        window.scrollTo({ top: top - 150, behavior: 'smooth' });
    });
}
